import { Component, OnInit, Inject } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-manpower-plan-vs-actual-poup',
  templateUrl: './manpower-plan-vs-actual-poup.component.html',
  styleUrls: ['./manpower-plan-vs-actual-poup.component.scss'],
})
export class ManpowerPlanVsActualPoupComponent  implements OnInit {
  buttonColorName:any
  loggedInUserCompanyID:any;
  loggedInCompanyFiscalyear:any;
  loggedInCompanyMDID:any;
  loggedInUserId:any;
  loggedInUserRole:any;
  FiscalYear:any
  fromYear:any;
  toYear:any;
  currentMonth:any;
  getManpowerPlanvsActualData:any = [];
  getMonth:any

  constructor( private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.getMonth = this.data.month;
    this.fromYear = this.data.fromYear;
    this.toYear = this.data.toYear
    
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if(sessionStorage.getItem('loggedInCompanyMDID')){
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    console.warn("loggedInUserId", this.loggedInUserId);
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');

   const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  // Get current month index and convert to month name
  //  this.currentMonth = monthNames[new Date().getMonth()];
  
   this.getManpowerPlanVsActual()
  }


  getManpowerPlanVsActual(){
    const request = {
      "companyId":this.loggedInUserCompanyID,
      "month":this.getMonth,
      "fromYear":this.fromYear,
      "toYear":this.toYear,
      "userId":this.loggedInUserId
    }
    this.httpService.callPostService(this.config.getManpowerPlanVsActual, request).subscribe((result:any)=>{
      this.getManpowerPlanvsActualData = result.data
    })
  }


  downloadExcel(dataFilter: any) {
    const flattenedData: any[] = [];
    dataFilter.forEach((department: any) => {
      department.bands.forEach((band: any) => {
        flattenedData.push({
          "Department": department.department,
          "Band": band.band,
          "Plan (Active +vacant) -A": band.plan,
          "Actual (active in employee Master)-B": band.actual,
          "Gap (A-B)": band.gap,
        });
      });
    });
  
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const worksheet: XLSX.WorkSheet | any = XLSX.utils.json_to_sheet(flattenedData);
  
    // Style for header row
    const headerStyle = {
      fill: {
        fgColor: { rgb: 'FF0000' }
      },
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' },
        sz: 14,
        name: "Arial",
      },
      alignment: { horizontal: 'right' } 
    };
  
    const bodyStyle = {
      alignment: { horizontal: 'right' } 
    };
  
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }
  
    for (let row = 1; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = bodyStyle;
      }
    }
  
    worksheet['!cols'] = [
      { wpx: 150 },
      { wpx: 100 },
      { wpx: 150 },
      { wpx: 200 },
      { wpx: 100 },
    ];
  
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Manpower_Plan_vs_Actual.xlsx';
    saveAs(data, fileName);
  }
  
}
